<template>
  <div>
    <!-- <div class="mt-5">
      <div class="row">
        <div class="col-lg-4 mb-3">
          <div class="grid-table grid-table_col-2">
            <div class="grid-table__item mb-2">Дата обращения:</div>
            <div class="grid-table__item mb-2">07.12.2025</div>
            <div class="grid-table__item mb-2">Сумма заявки:</div>
            <div class="grid-table__item mb-2">38 970 000</div>
          </div>
        </div>
        <div class="col-lg-4 mb-3">
          <div class="grid-table grid-table_col-2">
            <div class="grid-table__item mb-2">На проверке:</div>
            <div class="grid-table__item mb-2">1 документ</div>
            <div class="grid-table__item mb-2">Осталось загрузить:</div>
            <div class="grid-table__item mb-2">6 документов</div>
            <div class="grid-table__item mb-2">Согласовано:</div>
            <div class="grid-table__item mb-2">1 документ</div>
          </div>
        </div>
        <div class="col-lg-4 mb-3">
          <div class="grid-table grid-table_col-2">
            <div class="grid-table__item mb-2">Список обновлен:</div>
            <div class="grid-table__item mb-2">28.12.2025 14:32</div>
          </div>
        </div>
      </div>
    </div> -->

    <!-- <div>
      <h2 class="mt-4">Паспорт руководителя</h2>
      <div class="hr mt-2"></div>

      <div class="alert alert-info mt-4 mb-4">
        Прикрепите скан или фото паспорта руководителя.
      </div>

      <input
        type="file"
        ref="file"
        style="display: none"
        @change="addFile"
        multiple
      />

      <ui-table v-if="filesPass && filesPass.length > 0" class="mb-4">
        <table class="table">
          <tbody>
            <tr v-for="(item, index) in filesPass" :key="index">
              <td>
                <div v-if="item.Status == 0" class="text-danger text-nowrap">
                  Не принято
                </div>
                <div
                  v-else-if="item.Status == 1"
                  class="text-success text-nowrap"
                >
                  Принято
                </div>
              </td>
              <td class="w-100 text-nowrap">
                <div class="d-flex">
                  <button @click="downloadPass(item.Id)" class="btn-link">
                    <ui-loading-span v-if="item.loadingDownload" class="me-2" />

                    <i v-else class="icon-download me-2"></i>{{ item.DocFile }}
                  </button>
                </div>
              </td>
              <td class="text-end">
                <div class="d-flex flex-wrap gap-2">
                  <ui-button
                    @click="delPass(item.Id)"
                    :loading="item.loading"
                    class="btn btn-ghost btn-small"
                    >Удалить</ui-button
                  >
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </ui-table>
    </div>

    <div class="row">
      <div class="col-auto">
        <div class="d-flex flex-wrap gap-2">
          <ui-button
            v-if="filesPass && filesPass.length > 0"
            class="btn btn-ghost"
            @click="$refs.file.click()"
            :progress="btnUpload ? btnUpload : 0"
            :loading="loadingUpload"
            :disabled="loading || loadingUpload"
          >
            Прикрепить еще файл
          </ui-button>

          <ui-button
            v-else
            class="btn btn-base"
            @click="$refs.file.click()"
            :progress="btnUpload ? btnUpload : 0"
            :loading="loadingUpload"
            :disabled="loading || loadingUpload"
          >
            Прикрепить файл
          </ui-button>
        </div>
      </div>
    </div> -->

    <!-- 
    <div class="page-title">Документы для одобрения заявки на лизинг</div>
    <div class="hr mb-4"></div> -->

    <div class="mt-5">
      <div class="row">
        <div class="col-lg-6 mb-3">
          <div class="grid-table grid-table_col-2">
            <div class="grid-table__item mb-2">Предмет лизинга:</div>
            <div class="grid-table__item mb-2">
              {{ leasing.KPPL_Name ? leasing.KPPL_Name : "&#8212;" }}
            </div>
            <div class="grid-table__item mb-2">Поставщик:</div>
            <div class="grid-table__item mb-2">
              {{
                leasing.KPPL_SupplierName
                  ? leasing.KPPL_SupplierName
                  : "&#8212;"
              }}
            </div>
            <div class="grid-table__item mb-2">Сумма расчета:</div>
            <div class="grid-table__item mb-2">
              {{ leasing.Amount ? moneyMask(leasing.Amount) : "&#8212;" }}
            </div>
          </div>
        </div>
        <div class="col-lg-6 mb-3">
          <div class="grid-table grid-table_col-2">
            <div class="grid-table__item mb-2">Аванс:</div>
            <div class="grid-table__item mb-2">
              {{
                leasing.Adv
                  ? moneyMask((leasing.Price * leasing.Adv) / 100)
                  : "&#8212;"
              }}
            </div>

            <div class="grid-table__item mb-2">Срок лизинга :</div>
            <div class="grid-table__item mb-2">
              {{ leasing.SL ? leasing.SL + " мес." : "&#8212;" }}
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="hr mt-3"></div>

    <ui-table class="mt-4">
      <table class="table">
        <tbody>
          <tr v-if="docs?.anketa">
            <td>
              <!-- <div class="text-success text-nowrap">Принято</div> -->
              <!-- <div class="text-danger text-nowrap">Не принято</div> -->

              <div
                v-if="docs?.anketa?.Status == 1"
                class="text-success text-nowrap"
              >
                Принято
              </div>

              <div
                v-else-if="docs?.anketa?.Status == 0"
                class="text-danger text-nowrap"
              >
                Не принято
              </div>
            </td>

            <td class="w-100 text-nowrap">
              <div class="d-flex">
                <router-link
                  class="d-flex align-items-center line-height-1_2"
                  :to="route.params.id + '/application'"
                  >Анкета лизингополучателя ({{ docs?.anketa.LPName }},
                  ИНН {{ docs?.anketa.LPINN }})</router-link
                >
              </div>
            </td>
            <td class="text-end">
              <!-- <ui-button class="btn btn-base btn-small">
                Подробнее
              </ui-button> -->
              <router-link
                :to="route.params.id + '/application'"
                class="btn btn-base btn-small"
              >
                Заполнить и подписать
              </router-link>
            </td>
          </tr>
          <tr v-if="docs?.dirSopd">
            <td>
              <div
                v-if="docs?.dirSopd?.Status >= 1"
                class="text-success text-nowrap"
              >
                Принято
              </div>
              <div
                v-else-if="docs?.dirSopd?.Status >= 0"
                class="text-danger text-nowrap"
              >
                Не принято
              </div>
            </td>
            <td class="w-100 text-nowrap">
              <div class="d-flex">
                <router-link
                  class="d-flex align-items-center line-height-1_2"
                  :to="route.params.id + '/personal-data-consent'"
                  >Согласие на обработку персональных данных ({{
                    formatFIO(docs?.dirSopd)
                  }}, ИНН {{ docs?.dirSopd.inn }})</router-link
                >
              </div>
            </td>
            <td class="text-end">
              <router-link
                :to="route.params.id + '/personal-data-consent'"
                class="btn btn-base btn-small"
              >
                Заполнить и подписать
              </router-link>
            </td>
          </tr>

          <!-- <tr>
            <td>
              <div class="text-danger text-nowrap">Не принято</div>
            </td>
            <td class="w-100 text-nowrap">
              <div class="d-flex">
                <router-link :to="'/sign'" target="_blank"
                  >Согласие на обработку персональных данных (Сенчихин М. В.,
                  ИНН 503225878040)
                </router-link>
              </div>
            </td>
            <td class="text-end">
              <router-link
                :to="route.params.id + '/personal-data-consent'"
                class="btn btn-ghost btn-small"
              >
                Отправить ссылку
              </router-link>
            </td>
          </tr> -->

          <template v-if="docs?.sopd && docs?.sopd.length > 0">
            <tr v-for="(item, index) in docs.sopd" :key="index">
              <td>
                <div v-if="item?.Status >= 1" class="text-success text-nowrap">
                  Принято
                </div>
                <div
                  v-else-if="item?.Status >= 0"
                  class="text-danger text-nowrap"
                >
                  Не принято
                </div>
              </td>
              <td class="text-nowrap">
                <div class="d-flex">
                  <a
                    :href="'https://lc.stone-xxi.ru/sign/?UID=' + item.RID"
                    target="_blank"
                    class="text-decoration-none"
                    >Согласие на обработку персональных данных ({{
                      formatFIO(item)
                    }}, ИНН {{ item.inn }})
                  </a>
                </div>
              </td>
              <td class="text-end">
                <div v-if="item?.Status >= 1" class="text-success">
                  <div
                    class="d-flex flex-wrap gap-1 flex-nowrap justify-content-end"
                  >
                    <ui-button
                      :to="'https://lc.stone-xxi.ru/sign/?UID=' + item.RID"
                      class="btn btn-base btn-small"
                    >
                      Подробнее
                    </ui-button>
                  </div>
                </div>
                <div v-else-if="item?.Status >= 0" class="text-danger">
                  <div
                    class="d-flex flex-wrap gap-1 flex-nowrap justify-content-end"
                  >
                    <ui-button
                      @click="() => modalClose(item)"
                      class="btn btn-ghost btn-small"
                    >
                      Отправить ссылку
                    </ui-button>

                    <a
                      :href="'https://lc.stone-xxi.ru/sign/?UID=' + item.RID"
                      target="_blank"
                      class="btn btn-base btn-small"
                    >
                      Заполнить и подписать
                    </a>
                  </div>
                </div>
              </td>
            </tr>
          </template>
        </tbody>
      </table>
    </ui-table>

    <div v-if="error" class="login-alert p-3 text-center mt-4">
      <div class="text-primary">Внимание!</div>
      <div>{{ error }}</div>
    </div>

    <div class="row mt-4">
      <div class="col-auto">
        <div class="d-flex flex-wrap gap-2">
          <ui-button
            class="btn btn-ghost"
            @click="back"
            :loading="loadingBack"
            :disabled="loadingUpload || loadingBack || loading"
          >
            Вернуться к расчету
          </ui-button>

          <ui-button
            class="btn btn-base"
            @click="next"
            :loading="loading"
            :disabled="loadingUpload || loadingBack || loading"
          >
            Отправить на одобрение
          </ui-button>
        </div>
      </div>
    </div>

    <ui-modal v-if="modal" :close="modalClose">
      <div class="modal-header">
        <h5 class="modal-title">Отправить ссылку</h5>
        <button class="btn-close" type="button" @click="modalClose"></button>
      </div>
      <div class="modal-body">
        <p>Введите e-mail учредителя для отправки ссылки.</p>

        <!-- <ui-input-box :error="errorsLink.message">
        <ui-textarea v-model="message" placeholder="Сообщение" rows="3" />
      </ui-input-box> -->

        <ui-input-box-floating :error="errorsLink?.FounderFLINN">
          <ui-input type="text" v-model="email" placeholder="E-mail" />
          <ui-input-label>E-mail</ui-input-label>
        </ui-input-box-floating>

        <div v-if="errorLink" class="login-alert p-3 text-center mt-3">
          <div class="text-primary">{{ errorLink.error }}</div>
          <span>{{ errorLink.msg }}</span>
        </div>

        <div v-if="successLink" class="success-alert p-3 text-center mt-3">
          <div class="text-primary">Внимание!</div>
          <span>{{ successLink }}</span>
        </div>

        <ui-button
          @click="sendLink"
          class="btn-base mt-3 me-2"
          :loading="loadingSendLink"
          >Отправить</ui-button
        >
      </div>
      <!-- <div class="modal-footer"></div> -->
    </ui-modal>
  </div>
</template>



<script setup>
import { ref, watch } from "vue";

import { postApi, downloadApi, moneyMask, dateMask, uploadApi } from "@/run";

import { useRoute } from "vue-router";

// Получаем текущий маршрут
const route = useRoute();

const props = defineProps({
  setStatus: {
    type: Function,
  },
  docs: {
    filesPass: {
      type: Array,
      default: () => {},
    },
  },
  leasing: {
    filesPass: {
      type: Array,
      default: () => {},
    },
  },
  filesPass: {
    type: Array,
    default: () => [],
  },
});

const formatFIO = (item) => {
  const ln = item.LastName || "";
  const fn = item.FirstName ? item.FirstName[0] + "." : "";
  const mn = item.MidName ? item.MidName[0] + "." : "";
  return `${ln} ${fn} ${mn}`;
};

const loading = ref(false);
const error = ref(false);

const next = () => {
  loading.value = true;
  error.value = false;

  postApi("/leasing/setStatus", {
    id: route.params.id,
    status: 2,
  }).then((response) => {
    if (response.error) {
      error.value = response.error;
    }

    response.Status && props.setStatus(response.Status);

    loading.value = false;
  });
};

const loadingBack = ref(false);

const back = () => {
  loadingBack.value = true;

  postApi("/leasing/setStatus", {
    id: route.params.id,
    status: 0,
  }).then((response) => {
    (response.Status || response.Status == 0) &&
      props.setStatus(response.Status);

    loadingBack.value = false;
  });
};

const file = ref(null);
const files = ref([]);
const docs = ref([]);
const filesPass = ref([]);

const btnUpload = ref(null);
const loadingUpload = ref(false);

const progressUpload = (btnRef, progress) => {
  btnRef.value = progress;
};

const addFile = (e) => {
  error.value = null;
  files.value = [...files.value, ...Array.from(e.target.files)];
  file.value.value = null;

  loadingUpload.value = true;

  uploadApi(
    "/leasing/addFile",
    {
      files: files.value,
      data: {
        type: 23,
        id: route.params.id,
      },
    },
    btnUpload,
    progressUpload
  )
    .then((response) => {
      btnUpload.value = null;

      if (response.files) {
        filesPass.value = response.files;
      }
    })
    .finally(() => {
      loadingUpload.value = false;
      files.value = [];
    });
};

const delPass = (id) => {
  // Находим элемент в массиве
  const item = filesPass.value.find((f) => f.Id === id);
  if (!item) return;

  // Ставим флаг загрузки
  item.loading = true;

  postApi("/leasing/delFile", {
    id: id,
  })
    .then((response) => {
      if (response.status) {
        // Удаляем элемент из массива
        filesPass.value = filesPass.value.filter((f) => f.Id !== id);
      }
    })
    .finally(() => {
      item.loading = false;
    });
};

const progressDownload = (id, progress) => {
  console.log(id, progress);
};

const downloadPass = (id) => {
  const item = filesPass.value.find((f) => f.Id === id);
  if (!item) return;

  // Ставим флаг загрузки
  item.loadingDownload = true;

  downloadApi(
    "/leasing/downloadFile",
    {
      id: id,
    },
    id,
    progressDownload
  )
    .then((response) => {
      const jsonData =
        typeof response === "string" ? JSON.parse(response) : response;

      if (jsonData.error) {
        console.log({
          title: "Ошибка",
          msg: jsonData.error,
        });
      }
    })
    .finally(() => {
      item.loadingDownload = false;
    });
};

const modal = ref(false);
const email = ref(null);
const loadingSendLink = ref(false);
const errorLink = ref(null);
const errorsLink = ref(null);
const successLink = ref(null);

const modalClose = (item) => {
  errorLink.value = null;
  successLink.value = null;
  if (modal.value) {
    modal.value = null;
    email.value = null;
  } else {
    modal.value = item.RID;
    email.value = item.email;
  }
};

const sendLink = () => {
  errorLink.value = null;
  successLink.value = null;
  loadingSendLink.value = true;
  postApi("/sendLink", {
    sendEmail: email.value,
    UID: modal.value,
  }).then((res) => {
    if (res.error) {
      errorLink.value = res;
    } else {
      successLink.value = "Ссылка отправлена!";
    }
    loadingSendLink.value = false;
  });
};

watch(
  () => props.filesPass,
  (newVal) => {
    if (Array.isArray(newVal)) {
      filesPass.value = [...newVal];
    } else if (newVal && typeof newVal === "object") {
      filesPass.value = [newVal];
    } else {
      filesPass.value = [];
    }
  },
  { immediate: true }
);

watch(
  () => props.docs,
  (newVal) => {
    if (newVal && typeof newVal === "object") {
      docs.value = newVal;
    } else {
      docs.value = {};
    }
  },
  { immediate: true }
);
</script>